var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.92446 22.9995H1.36339V8.97922H5.92446V22.9995ZM3.64147 7.06672C2.18299 7.06672 1 5.91359 1 4.52141C1 3.85269 1.2783 3.21136 1.77367 2.7385C2.26904 2.26565 2.94091 2 3.64147 2C4.34204 2 5.0139 2.26565 5.50928 2.7385C6.00465 3.21136 6.28295 3.85269 6.28295 4.52141C6.28295 5.91359 5.09946 7.06672 3.64147 7.06672ZM22.9951 22.9995H18.4438V16.1745C18.4438 14.548 18.4095 12.462 16.0725 12.462C13.7011 12.462 13.3377 14.2292 13.3377 16.0573V22.9995H8.78152V8.97922H13.156V10.8917H13.2198C13.8287 9.79016 15.3162 8.62766 17.5354 8.62766C22.1514 8.62766 23 11.5292 23 15.298V22.9995H22.9951Z","fill":"white"}));
}

LinkedinInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
